import React from "react";
import get from "lodash/get";
import { object, bool, string } from "prop-types";
import { Link } from "@quintype/components";
import { getStoryHeadline, getStoryLabel, isExternalStory } from "../../utils/story";
import { PublishAndReadTime } from "../../atoms/PublishAndReadTime";
import { HeroImage } from "../../atoms/HeroImage";
import { Label } from "../../atoms/Label";
import Headline from "../../atoms/Headline";
import SubHeadline from "../../atoms/SubHeadline";

import "./three-col-nineteen-stories.m.css";

export const MainStory = ({ story, showHeroImage = true, showBorder, showReadTime, showTimestamp, sectionSlug }) => {
  const headline = getStoryHeadline(story);
  const label = getStoryLabel(story);
  const imageUrl =
    get(story, ["hero-image-s3-key"], "") ||
    get(story, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"], "");

  const externalStoryUrl = isExternalStory(story);
  const href = externalStoryUrl ? externalStoryUrl : `/${story?.slug}`;
  const target = externalStoryUrl ? "_blank" : "_self";
  return (
    <Link href={href} target={target}>
      <div styleName={`main-story  ${showBorder ? "" : "no-border"} ${showHeroImage ? "" : "hide-hero-image"}`}>
        {label && <Label story={story} />}

        {headline && <Headline styleName="main-story-headline" headline={headline} sectionSlug={sectionSlug} />}

        {story?.subheadline && (
          <SubHeadline styleName="subheadline" subHeadline={story?.subheadline} sectionSlug={sectionSlug} />
        )}
        <PublishAndReadTime story={story} showReadTime={showReadTime} showTimestamp={showTimestamp} />
        {showHeroImage && (
          <HeroImage
            story={story}
            headline={headline}
            aspectRatio={[[4, 3]]}
            iconSizes={{ width: 64, height: 64 }}
            imageUrl={imageUrl}
          />
        )}
      </div>
    </Link>
  );
};

MainStory.propTypes = {
  story: object,
  showHeroImage: bool,
  showBorder: bool,
  showReadTime: bool,
  showTimestamp: bool,
  sectionSlug: string,
};
